// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/font/Calibre-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/font/Calibre-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/font/Calibre-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/font/Calibre-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/font/Calibre-Thin.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/font/Calibre-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/font/Calibre-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/font/Calibre-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/font/Calibre-LightItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/font/Calibre-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/font/Calibre-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/font/Calibre-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../assets/font/Calibre-MediumItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../assets/font/Calibre-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../assets/font/Calibre-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../assets/font/Calibre-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../assets/font/Calibre-BlackItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../assets/font/Calibre-BlackItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../assets/font/Calibre-BlackItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../assets/font/Calibre-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../assets/font/Calibre-Semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../assets/font/Calibre-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../assets/font/Calibre-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../assets/font/Calibre-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../assets/font/Calibre-Black.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../assets/font/Calibre-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../assets/font/Calibre-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../assets/font/Calibre-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../assets/font/Calibre-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../assets/font/Calibre-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../assets/font/Calibre-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../assets/font/Calibre-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../assets/font/Calibre-RegularItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../assets/font/Calibre-RegularItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../assets/font/Calibre-RegularItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../assets/font/Calibre-RegularItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../assets/font/Calibre-BoldItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../assets/font/Calibre-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../assets/font/Calibre-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../assets/font/Calibre-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../assets/font/Calibre-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../assets/font/Calibre-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../assets/font/Calibre-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../assets/font/Calibre-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../assets/font/Calibre-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../assets/font/Calibre-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../assets/font/Calibre-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../assets/font/Calibre-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../assets/font/Calibre-SemiboldItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../assets/font/Calibre-SemiboldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../assets/font/Calibre-SemiboldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../assets/font/Calibre-SemiboldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../assets/font/Calibre-ThinItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../assets/font/Calibre-ThinItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../assets/font/Calibre-ThinItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../assets/font/Calibre-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../assets/img/line_bg1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../assets/img/enterprize.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../assets/img/consumer.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../assets/img/automation.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../assets/img/monitor.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../assets/img/solve.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("../assets/img/bvb.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../assets/img/reality.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("../assets/img/handshake.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../assets/img/img_smart_fleet-min.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("../assets/img/ThreatEngine.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("../assets/img/EMR.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../assets/img/processautomation.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../assets/img/user.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../assets/img/mail.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../assets/img/Union.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("../assets/img/mail_footer.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_79___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_80___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_81___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_82___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_83___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_84___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_85___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_86___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! HTML5 Boilerplate v8.0.0 | MIT License | https://html5boilerplate.com/ */

/* main.css 2.1.0 | MIT License | https://github.com/h5bp/main.css#readme */
/*
 * What follows is the result of much research on cross-browser styling.
 * Credit left inline and big thanks to Nicolas Gallagher, Jonathan Neal,
 * Kroc Camen, and the H5BP dev community and team.
 */

/* ==========================================================================
   Base styles: opinionated defaults
   ========================================================================== */
body::-webkit-scrollbar {
  width: 0;
}

* {
  padding: 0;
  margin: 0;
}
@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local("Calibre Light"), local("Calibre-Light"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: local("Calibre Thin"), local("Calibre-Thin"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: local("Calibre Light Italic"), local("Calibre-LightItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  src: local("Calibre Medium Italic"), local("Calibre-MediumItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("truetype");
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  src: local("Calibre Black Italic"), local("Calibre-BlackItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_21___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("truetype");
  font-weight: 900;
  font-style: italic;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  src: local("Calibre Semibold"), local("Calibre-Semibold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_26___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("truetype");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  src: local("Calibre Black"), local("Calibre-Black"),
    url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("truetype");
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  src: local("Calibre Medium"), local("Calibre-Medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  src: local("Calibre Regular Italic"), local("Calibre-RegularItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_41___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_43___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_44___}) format("truetype");
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  src: local("Calibre Bold Italic"), local("Calibre-BoldItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_46___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_47___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_48___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_49___}) format("truetype");
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  src: local("Calibre Bold"), local("Calibre-Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_51___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_52___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_54___}) format("truetype");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
  src: local("Calibre"), local("Calibre-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_56___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_57___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_58___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_59___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
  src: local("Calibre Semibold Italic"), local("Calibre-SemiboldItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_61___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_62___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_63___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_64___}) format("truetype");
  font-weight: 600;
  font-style: italic;
}

@font-face {
  font-family: "Calibre";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
  src: local("Calibre Thin Italic"), local("Calibre-ThinItalic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_66___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_67___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_68___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_69___}) format("truetype");
  font-weight: 100;
  font-style: italic;
}

html {
  color: #222;
  font-size: 1.2em;
  line-height: 1.4;
  font-family: "Calibre", sans-serif;
  font-weight: 300;
  background-color: #131313;
  overflow: hidden;
}
#root {
  overflow: hidden;
  /* overflow-y: scroll; */
  /* position: relative; */
}
#root::before {
  content: "";
  position: fixed;
  width: 200%;
  height: 200%;
  top: -50%;
  left: -50%;
  z-index: -1;
  background: #131313 url(${___CSS_LOADER_URL_REPLACEMENT_70___}) no-repeat 73% 20vh;
  transform: rotate(-270deg);
  -webkit-transition: all 1s linear;
  background-size: 35%;
}
#root.magic-root-before::before {
  /* left:-70%; */
}
/* -webkit-transition: all 1s ease-in;
}
#root.magic-root-before::before{
  transform: rotate(90deg);
  left:-80%;
  top:-30%;
  
  
} */
/* #root.magic-root-before2::before{
  transform: rotate(-30deg);
  left:-40%;
  top:-50%;
  
  
} */

/* .white-bg.black-rhombuz::before{
  content: "";
  position: fixed;
  width: 200%;
  height: 200%;
  top: -50%;
  left: -50%;
  z-index: -1; 
  background: #fff url(../assets/img/line_bg1_black.svg) no-repeat 50% 50vh;
  transform: rotate(0deg);
  -webkit-transition: all 1s ease-in;
} */

/*
 * Remove text-shadow in selection highlight:
 * https://twitter.com/miketaylr/status/12228805301
 *
 * Vendor-prefixed and regular ::selection selectors cannot be combined:
 * https://stackoverflow.com/a/16982510/7133471
 *
 * Customize the background color to match your design.
 */

::selection {
  background: #b3d4fc;
  text-shadow: none;
}

/*
 * A better looking default horizontal rule
 */

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}

/*
 * Remove the gap between audio, canvas, iframes,
 * images, videos and the bottom of their containers:
 * https://github.com/h5bp/html5-boilerplate/issues/440
 */

audio,
canvas,
iframe,
img,
svg,
video {
  vertical-align: middle;
}

/*
 * Remove default fieldset styles.
 */

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

/*
 * Allow only vertical resizing of textareas.
 */

textarea {
  resize: vertical;
}

/* ==========================================================================
   Author's custom styles
   ========================================================================== */

/* ==========================================================================
   Helper classes
   ========================================================================== */

/*
 * Hide visually and from screen readers
 */

.hidden,
[hidden] {
  display: none !important;
}

/*
 * Hide only visually, but have it available for screen readers:
 * https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
 *
 * 1. For long content, line feeds are not interpreted as spaces and small width
 *    causes content to wrap 1 word per line:
 *    https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
 */

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  /* 1 */
}

/*
 * Extends the .sr-only class to allow the element
 * to be focusable when navigated to via the keyboard:
 * https://www.drupal.org/node/897638
 */

.sr-only.focusable:active,
.sr-only.focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  white-space: inherit;
  width: auto;
}

/*
 * Hide visually and from screen readers, but maintain layout
 */

.invisible {
  visibility: hidden;
}

/*
 * Clearfix: contain floats
 *
 * For modern browsers
 * 1. The space content is one way to avoid an Opera bug when the
 *    \`contenteditable\` attribute is included anywhere else in the document.
 *    Otherwise it causes space to appear at the top and bottom of elements
 *    that receive the \`clearfix\` class.
 * 2. The use of \`table\` rather than \`block\` is only necessary if using
 *    \`:before\` to contain the top-margins of child elements.
 */

.clearfix::before,
.clearfix::after {
  content: " ";
  display: table;
}

.clearfix::after {
  clear: both;
}

/* ==========================================================================
   EXAMPLE Media Queries for Responsive Design.
   These examples override the primary ('mobile first') styles.
   Modify as content requires.
   ========================================================================== */

@media only screen and (min-width: 35em) {
  /* Style adjustments for viewports that meet the condition */
}

@media print,
  (min-resolution: 1.25dppx),
  (min-resolution: 120dpi) {
  /* Style adjustments for high resolution devices */
}

/* ==========================================================================
   Print styles.
   Inlined to avoid the additional HTTP request:
   https://www.phpied.com/delay-loading-your-print-css/
   ========================================================================== */

@media print {
  *,
  *::before,
  *::after {
    background: #fff !important;
    color: #000 !important;
    /* Black prints faster */
    box-shadow: none !important;
    text-shadow: none !important;
  }

  a,
  a:visited {
    text-decoration: underline;
  }

  a[href]::after {
    content: " (" attr(href) ")";
  }

  abbr[title]::after {
    content: " (" attr(title) ")";
  }

  /*
   * Don't show links that are fragment identifiers,
   * or use the \`javascript:\` pseudo protocol
   */
  a[href^="#"]::after,
  a[href^="javascript:"]::after {
    content: "";
  }

  pre {
    white-space: pre-wrap !important;
  }

  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
  }

  /*
   * Printing Tables:
   * https://web.archive.org/web/20180815150934/http://css-discuss.incutio.com/wiki/Printing_Tables
   */
  thead {
    display: table-header-group;
  }

  tr,
  img {
    page-break-inside: avoid;
  }

  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }

  h2,
  h3 {
    page-break-after: avoid;
  }
}
h1 {
  font-size: 6.5em;
  font-weight: normal;
}
h2 {
  font-size: 3.8em;
}
h3 {
  font-size: 2em;
  line-height: 1.1em;
  font-weight: 300;
  margin-block-start: 0;
}
.bold {
  font-weight: bold;
}
h4 {
  font-size: 1.5em;
  font-weight: normal;
  margin-block-start: 0;
}
h5 {
  font-size: 1.1em;
}
ul {
  padding-inline-start: 0;
  list-style: none;
  display: flex;
}

.fullpage {
  height: 100vh;
  width: 100%;
}
/*Home Header*/
.banner {
  color: #fff;
  box-sizing: border-box;
  position: relative;
  /* background: #131313 url("../assets/img/bg_hero_banner@3x.png") no-repeat 0 0; */
  background-size: contain;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.banner .title-header {
  position: absolute;
  top: 50%;
  width: 100%;
}
.banner h1 {
  margin-left: 8.7%;
  /* background: 50% 100% / 50% 50% no-repeat
              radial-gradient(ellipse at bottom, #fff, #fff, #fff); */
  background: radial-gradient(ellipse at bottom, #fff, #fff, #fff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-size: 6em;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  animation: glow 2500ms linear 2000ms;
  /* animation: reveal 3000ms ease-in-out forwards 200ms,
             glow 2500ms linear 2000ms; */
}
@keyframes reveal {
  80% {
    letter-spacing: 8px;
  }
  100% {
    background-size: 300% 300%;
  }
}
@keyframes glow {
  40% {
    text-shadow: 0 0 8px #fff;
  }
}

.banner .fusion {
  margin-left: 9.1%;
  font-size: 1.4em;
  width: 70vw;
}

/*Header End*/
/*List Styles*/

.nav li {
  flex: 0 1 auto;
  flex-basis: auto;
  margin-right: 3em;
  box-sizing: content-box;
  cursor: pointer;
  display: inline-block;
  line-height: 1.8em;
}
.nav.fusion li {
  cursor: auto;
  margin-top: -1em;
}

/*List Styles Ends*/

.flex-row {
  display: flex;
  flex: 1 1;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
}
.content-section {
  width: 75%;
  padding-top: 3em;
  margin: auto;
  text-align: center;
  box-sizing: border-box;
  color: #131313;
}
.scalable > .content-section {
  color: #fff;
  margin: 4em auto 4em;
  padding-top: 1em;
}
.scalable > .content-section > h3 {
  margin-bottom: 1.5em;
}
.content-section > div {
  margin-bottom: 3.5%;
  font-size: 1.2em;
}
.flex-row > div {
  padding-top: 12%;
  width: 50%;

  /* margin-right: 10%; */
  vertical-align: top;
  box-sizing: border-box;
}
.magic-section {
  height: 100%;
  position: absolute;
  left: 0;
  z-index: 5;
  padding-bottom: 10%;

  background-size: auto 160%;
  color: #ccc;
}
.magic-section h3 {
  padding: 0 18%;
  transform: translate(-20%, -5px);
  opacity: 0;
  -webkit-transition: all 1s ease-in-out;
}
.top-pad-header {
  padding-top: 8%;
}
.hiring-top {
  padding-top: 20%;
}
.black-bg {
  background-color: #131313;
}
.white-bg {
  background-color: #fff;
}
.magic-content {
  padding-right: 10.5% !important;
  height: 100vh;
  opacity: 0;
  color: #fff;
  transform: translate(20%, 0px);
  -webkit-transition: all 1s ease-in-out;
  /* -webkit-transition-delay: 0.8s; */
  font-size: 1.2em;
  line-height: 1.6em;
}

.magic-content b {
  font-weight: 800;
}
.magic-section b {
  font-weight: 600;
  color: #fff;
}
h3 b {
  font-weight: 600;
}
.relative {
  position: relative;
}
.contactus-form {
  width: 98%;
  top: -0.2em;
}
.impact li {
  padding-top: 5em;
  margin-top: 2em;
  margin-right: 2vw;
  margin-left: 2vw;
  text-align: center;
  width: 25%;
  box-sizing: border-box;
  font-size: 1em;
}
.impact li p {
  padding: 0 0.6em;
}

.impact-solve li {
  width: 33%;
}

.impact li h6 {
  padding-bottom: 2vh;
  font-weight: bold;
  font-size: 1.2em;
}
.text-uppercase {
  text-transform: uppercase;
}
.etools {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_71___}) no-repeat 50% 0;
  background-size: 17%;
}
.capps {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_72___}) no-repeat 50% 0;
  background-size: 16%;
}
.pauto {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_73___}) no-repeat 50% 0;
  background-size: 17%;
}
.monitor {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_74___}) no-repeat 50% 0;
  background-size: 17%;
}
.solve {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_75___}) no-repeat 50% 0;
  background-size: 18%;
}
.bvb {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_76___}) no-repeat 50% 0;
  background-size: 18%;
}
.reality {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_77___}) no-repeat 50% 0;
  background-size: 16%;
}
/* .moving-white{
  height: 95vh;
  position: absolute;
  width:50%;
  right:0;
  z-index: 1;
  background: #fff;
} */
.movable {
  width: 70%;

  margin: auto;
  z-index: 5;
  position: relative;
}
.impact.movable {
  width: 120%;
  margin-left: -10%;
}
.scalablebg {
  background: #131313;
  height: auto;
}
.scalable {
  width: 100vw;
  color: #fff;
  position: sticky;
  top: 5em;
}
.scalable-movable {
  position: absolute;
  height: 110%;
  background-color: #131313;
  width: 50%;
  z-index: -1;
}
.carousel-container {
  width: 80vw;
  position: relative;
  left: -8.5vw;
  box-sizing: border-box;
  /* overflow-x: scroll; */
  height: 50vh;
  margin-top: 10vh;
}
.only-tiles {
  display: flex;
  flex-direction: row;
}
.only-tiles > div {
  width: 33%;
  margin: 0 3em;
  box-sizing: border-box;
  -webkit-transition: all 0.6s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  cursor: pointer;
}
.only-tiles > div > div {
  border-radius: 1em;
  filter: grayscale(0.2);
  -webkit-transition: all 1s ease-in;
}
.only-tiles > div > div:hover {
  filter: grayscale(0);
}
.only-tiles > div:hover {
  transform: scale(1.2);
}

.carousel {
  width: 150vw;
  margin: 0 20%;
  display: flex;
}

@keyframes translateX {
  0% {
    transform: translate(5000px, 0);
  }
  100% {
    transform: translate(0px, 0);
  }
}
.carousel div {
  width: 26vw;
  margin: 0.5em 1.5em;
  height: 45vh;
  overflow: hidden;
  position: relative;
}
.carousel div > p {
  position: absolute;
  z-index: 1;
  top: 25%;
  font-weight: 500;
  color: #fff;
  background: rgba(0, 0, 0, 0.35);
  left: 0px;
  padding: 0 20px;
  font-size: 1.5em;
}
.carousel div > p:nth-child(2) {
  position: absolute;
  z-index: 1;
  top: calc(25% + 1.38em);
  left: 7%;
}
.carousel div > p:nth-child(3) {
  position: absolute;
  z-index: 1;
  top: 80%;
  font-size: 0.75em;
  cursor: pointer;
  background: rgba(10, 10, 10, 0.75);
  left: 0px;
}
/* .carousel .cmp1{
  
  animation: translateX 2s;
  animation-delay: 1s;
  animation-timing-function: ease-in-out;
}
.carousel .cmp2{
  
  animation: translateX 3s;
  animation-delay: 2s;
  animation-timing-function: ease-in-out;
}
.carousel .cmp3{
 
  animation: translateX 4s;
  animation-delay: 3s;
  animation-timing-function: ease-in-out;
}
.carousel .cmp4{
  
  animation: translateX 5s;
  animation-delay: 4s;
  animation-timing-function: ease-in-out;
} */

.carousel img {
  width: 100%;
}
button {
  margin-top: 4em;
  background: #131313;
  color: #fff;
  font-size: 1em;
  font-weight: 400;
  line-height: 4em;
  padding: 0 10vw;
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  -ms-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  cursor: pointer;
  border: none;
}
button:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}
.margintop5 {
  margin-top: 2.5em;
}

footer {
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
}
.footer-contact {
  width: 81.5%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75em;
}
.footer-contact div {
  padding: 2.5em 0;
}

.content {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: auto;
  height: 17rem;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  z-index: 10;
}
#slider,
#slider2 {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  display: flex;
  flex-direction: column-reverse;
  position: relative;
  vertical-align: middle;
}

.content img {
  width: auto;
  max-width: 75%;
  height: 90%;
  right: 0;
  position: absolute;
}
.content p {
  margin-left: 25%;
  z-index: 1;
  position: relative;
  margin-bottom: 50%;
  font-weight: 600;
}
.content p:nth-child(2) {
  margin-left: 18%;
  margin-bottom: 0%;
}
.movable-parallax-1 {
  margin-top: 37em;
}
/* .movable-parallax-1-{
  margin-top: -22em;
} */
#scroll-horizontal {
  height: 150vw;
}
.listening-triangle {
  width: 0;
  height: 0;
  border: 0 solid transparent;
  border-right-width: 100vw;
  border-left-width: 0vw;
  border-top: 7em solid #f3f3f3;
  position: absolute;
  top: 5em;
  left: -16.5%;
  margin-bottom: 0px !important;
}
.announcement {
  position: absolute;
  margin-left: 50%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_78___}) no-repeat 0 0;
  background-size: 100%;
  width: 7em;
  height: 7em;
  left: -3.5em;
  top: 4em;
  margin-bottom: 0px !important;
  transition: transform 0.2s;
}
/* .announcement:hover{
  transform: scale(1.2); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) 
} */
nav > .nav > li:hover {
  transform: scale(
    1.1
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
.announcemnet-cover {
  background-color: #f3f3f3;
  height: 5em;
  width: 100vw;
  left: -16.5%;
  position: absolute;
  top: 0;
}

.grey {
  background-color: #f3f3f3;
  display: inline-block;
  position: relative;
  height: 100vh;
  width: 100vw;
}
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) and (hover: none) {
  .grey {
    max-height: 800px;
  }
  .wowhide {
    opacity: 1 !important;
    transform: translate(0, 0px) !important;
  }
  .hiring-top {
    padding-top: 25%;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1) {
  .grey {
    max-height: 800px;
  }
  .wowhide {
    opacity: 1 !important;
    transform: translate(0, 0px) !important;
  }
  .hiring-top {
    padding-top: 25%;
  }
  nav {
    padding: 2em !important;
  }
  .nav li {
    margin-right: 2em;
  }
}
@media only screen and (min-width: 760px) {
  .align-start .element {
    scroll-snap-align: start;
  }

  .both-mandatory {
    scroll-snap-type: both mandatory;
  }
  .element {
    scroll-snap-stop: normal;

    position: relative;
  }
  .wowhide {
    opacity: 0;
    transition: all 0.6s ease-in-out;
    transform: translate(0, 50px);
  }
  .wowup {
    transform: translate(0, 0);
    opacity: 1;
  }
  @supports (scroll-snap-type: both mandatory) {
    .no-support {
      display: none;
    }
  }
}
.container {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
.container::-webkit-scrollbar {
  width: 0;
}
.lefttext {
  text-align: left;
}

/*About Page*/

.about-banner {
  height: 82vh;
  /* background: #000 url(../assets/img/bg_hero_banner@3xabout.png) no-repeat 0 0; */
  background-size: 100%;
  background-position: bottom;
  position: relative;
  z-index: 1;
}

canvas {
  width: 100%;
  height: 100%;
}
.seperator {
  position: absolute;
  width: 0.5em;
  top: 90vh;
  background-color: #000;
  left: 50%;
}
.seperator-right {
  padding-left: 5em;
}
.seperator-friendly {
  position: relative;
  z-index: 5;
  padding: 2em 0;
  background-color: #fff;
}
.form-function-text {
  font-size: 2em;
}
.item p,
.item-right p {
  white-space: break-spaces;
}
.item-right p {
  padding-right: 1em;
}
.left-of-seperator {
  width: 45%;
  text-align: right;
  padding-right: 1em;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
}
.services-content {
  margin-top: 2em;
  line-height: 2em;
}
.third-left-child {
  margin-top: -8vh;
}
.right-of-seperator {
  width: 45%;
  text-align: left;
  margin-top: -8vh;
  box-sizing: border-box;
  margin-left: 55%;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}
.services-text {
  /* text-decoration: underline; */
  /* padding-top: 2em; */
  /* text-underline-offset: 5px; */
  line-height: 2em;
  font-size: 1em;
  font-weight: 500;
  /* text-decoration-thickness: 3px; */
}

@media only screen and (min-width: 760px) {
  .item {
    display: inline-block;
    position: relative;
    right: -100%;
    width: 100%;
    transition: right 0.7s cubic-bezier(0.075, 0.82, 0.165, 1),
      transform 0.7s cubic-bezier(0.075, 0.82, 0.165, 1),
      opacity 1.5s cubic-bezier(0.075, 0.82, 0.165, 1);
    opacity: 0;
  }
  .item-right {
    display: inline-block;
    position: relative;
    left: -105%;
    width: 100%;
    transition: right 0.7s cubic-bezier(0.075, 0.82, 0.165, 1),
      transform 0.7s cubic-bezier(0.075, 0.82, 0.165, 1),
      opacity 1.5s cubic-bezier(0.075, 0.82, 0.165, 1);
    opacity: 0;
  }
  .item-display {
    transform: translateX(-100%);
    opacity: 1;
  }
  .item-display-right {
    transform: translateX(110%);
    opacity: 1;
  }
}
.about-done-that {
  background-color: #161616;
  position: relative;
  padding-top: 2em;
}
.about-done-that .content-section,
.about-black .content-section {
  color: #fff;
}
.nav-top-pad {
  padding-top: 4em;
}
.reasons-heading {
  font-size: 1.4em;
  font-weight: 500;
}
.about-done-that .nav li {
  width: 33%;
  line-height: 2.7em;
  text-transform: uppercase;
  font-size: 0.85em;
}
.top-pad-1 {
  padding-top: 1em;
}
.top-pad-3 {
  padding-top: 3em;
}
.top-pad-2 {
  padding-top: 2em;
}
.mobile-only {
  display: none;
}
.reasons {
  height: 50vh;
  width: 100%;
  background-size: 100%;
  margin-top: 10% !important;
  margin-bottom: 0px !important;
}
.padding-bottom-3 {
  padding-bottom: 3em;
}
.padding-bottom-5 {
  padding-bottom: 5em;
}
.text-align-right {
  text-align: right;
}

.work-banner {
  height: 90vh;
  /* height updating for work page banner,  it was initially 65vh */
  /* background: #000 url(../assets/img/bg_hero_work@3x.png) no-repeat 0 0; */
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 100%;
  background-position: bottom;
  position: relative;
  z-index: 1;
}
.contact-banner {
  height: 55.5vh;
  background-size: 100%;
  background-position: bottom;
  position: relative;
  z-index: 1;
}
.work-banner h2 {
  text-align: center;
  color: #fff;
  margin: 0;
  font-size: 3em;
}
.contact-banner h2 {
  text-align: center;
  color: #fff;
  font-size: 3em;
}

.about-banner h2 {
  text-align: center;
  color: #fff;
  margin: 0;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-51%, -50%);
  font-size: 3em;
}

.banner svg {
  height: 100vh;
}

/* .work-details{
    display: flex;
    flex-direction: column;
    scroll-snap-type: mandatory;
    scroll-snap-type: y mandatory;
    color: white;

  } */
.work-details-child {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  scroll-snap-align: start;
}
.about-banner > div,
.work-banner > div {
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 39%;
  gap: 1em;
}

.contact-banner > div {
  width: 100%;
  position: absolute;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  bottom: 0;
}
.odd-child {
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  scroll-snap-align: start;
}
.even-child {
  background: #fff;
  color: #000;
  scroll-snap-align: start;
}
.solution-description {
  width: 40%;
  font-size: 0.8em;
  padding: 0 2em 0;
  box-sizing: border-box;
  position: relative;
  height: 100%;
}
.solution-description p {
  margin: 0;
  position: absolute;
  width: 70%;
  top: 50%;
  left: 58%;
  transform: translate(-79%, -50%);
  -webkit-transition: all 1s ease-in-out;
  font-size: 1.2em;
  opacity: 0;
}
.odd-child .solution-description a {
  color: #fff;
  font-weight: 500;
}
.even-child .solution-description a {
  color: #000;
  font-weight: 500;
}
.solution-description p.opposite {
  transform: translate(-39%, -50%);
  opacity: 0;
  /* transform: translate(10%, 0%); */
  -ms-transform: translate(10%, 0%);
  -webkit-transition: all 1s ease-in-out;
  /* opacity: 0; */
  overflow: hidden;
}
/*ANimation solution description p*/
.solution-description p.animate {
  transform: translate(-59%, -50%);
  opacity: 1;
  height: 75%;
  /* transform: translate(10%, 0%); */
  -ms-transform: translate(10%, 0%);
  -webkit-transition: all 1s ease-in-out;
  overflow: hidden;
}
.solution-description p.animate .industry-info {
  color: rgba(176, 176, 176, 0.686);
  font-size: 1.7rem;
  font-weight: 500;
  line-height: 3rem;
}

.work-details-child div.animate {
  transform: translate(0%, 0%);
  opacity: 1;
}
.solution-img {
  width: 60%;
  overflow: hidden;
  transform: translate(10%, 0%);
  -ms-transform: translate(10%, 0%);
  -webkit-transition: all 1s ease-in-out;
}
.solution-img-opposite {
  width: 60%;
  overflow: hidden;
  transform: translate(-10%, 0%);
  -ms-transform: translate(-10%, 0%);
  -webkit-transition: all 1s ease-in-out;
}
.ehr {
  /* background: url(../assets/img/img_smart_ehr-min.jpeg) no-repeat 0% 30% !important; */
  transform: translate(10%, 0%);
  /* background-size: auto 103% !important; */
  -ms-transform: translate(10%, 0%);
  -webkit-transition: all 1s ease-in-out;
  /* opacity: 0; */
  overflow: hidden;
  /* background-size: 100% !important; */
  /* height: 80vh;
    margin: 17vh 0; */
}
.pandemic {
  /* background: url(../assets/img/img_pandamic-min.jpeg) no-repeat 0% 0% !important;
    background-size: auto 100% !important; */
  transform: translate(10%, 0%);
  -ms-transform: translate(10%, 0%);
  -webkit-transition: all 1s ease-in-out;
  /* opacity: 0; */
  overflow: hidden;
}
.itlfm {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_79___}) no-repeat 0% 30% !important;
  transform: translate(-10%, 0%);
  -ms-transform: translate(-10%, 0%);
  -webkit-transition: all 1s ease-in-out;
  /* opacity: 0; */
  overflow: hidden;
  /* background-size: 100% !important;
    height: 80vh;
    margin: 17vh 0; */
}
.gta {
  /* background: url(../assets/img/img_GTA-min.jpeg) no-repeat 100% 0% !important; */
  transform: translate(-10%, 0%);
  -ms-transform: translate(-10%, 0%);
  -webkit-transition: all 1s ease-in-out;
  /* opacity: 0; */
  overflow: hidden;

  /* background-size: auto 110% !important; */
  /* height: 80vh;
    margin: 17vh 0; */
}
.fleet {
  /* background: url(../assets/img/img_smart_fleet-min.jpeg) no-repeat 50% 30% !important; */
  transform: translate(-10%, 0%);
  /* background-size: auto 100% !important; */
  -ms-transform: translate(-10%, 0%);
  -webkit-transition: all 1s ease-in-out;
  /* opacity: 0; */
  overflow: hidden;
}
.italos {
  /* background: url(../assets/img/img_italos-min.jpeg) no-repeat 0% 0% !important; */
  transform: translate(10%, 0%);
  /* background-size: auto 100% !important; */
  -ms-transform: translate(10%, 0%);
  -webkit-transition: all 1s ease-in-out;
  /* opacity: 0; */
  overflow: hidden;
}

@keyframes showTopText {
  0% {
    transform: translate3d(0, 100%, 0);
    opacity: 0;
  }

  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
.animated-title > div.text-top div {
  animation: showTopText 0.7s cubic-bezier(0.075, 0.82, 0.165, 1);
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  bottom: 0;
  transform: translate(0, 100%);
}

.animated-title.second > div.text-top div {
  animation-delay: 1s;
}
.animated-title.third > div.text-top div {
  animation-delay: 1.25s;
}
.animated-title.fourth > div.text-top div {
  animation-delay: 1.5s;
}
.animated-title > div {
  height: 100%;
  overflow: hidden;
  position: absolute;
  width: 100%;
}

.animated-title {
  height: 2em;
  transform: translate(0%, -50%);
}
.fusion li {
  width: auto;
}

.transparent {
  color: transparent;
}
.magic-section-animate {
  transform: translate(0%, 0px);
  opacity: 1;
}
h3.magic-section-animate {
  transform: translate(0%, -5px);
  opacity: 1;
}
.colorfultext {
  font-size: 1rem;
  line-height: 2em;
  /* letter-spacing: 3px; */
  margin: auto;
  width: 98%;
  font-weight: 800;
  background: linear-gradient(90deg, #ffde31 47.31%, #ff3db2 52.42%);
  font-family: "Poppins", sans-serif;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
}
.MuiStepIcon-root {
  color: white !important;
}
.MuiStepIcon-text {
  fill: black !important;
}
.contact-banner .colorfultext {
  font-size: 1rem;
  line-height: 2em;
  /* letter-spacing: 3px; */
  margin: auto;
  width: 98%;
  font-weight: 800;
  background: linear-gradient(90deg, #ffde31 46.31%, #ff3db2 52.42%);
  font-family: "Poppins", sans-serif;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
}
.carousel-prev.block,
.carousel-next.block {
  height: 50vh;
}

.carousel-track,
.carousel-item {
  height: 50vh !important;
}
.carousel-item {
  width: 45vw !important;
  position: relative;
  left: 18vw !important;
}
.carousel-row p {
  position: absolute;
  bottom: 20px;
  width: 100%;
  text-align: center;
}
.carousel-row p:nth-child(2) {
  bottom: 0;
}
.carousel-row img {
  height: 40vh;
  width: 80%;
}
.carousel-bg {
  width: 100%;
  height: 40vh;
}
.bg-threatengine {
  background: linear-gradient(#fff0 0%, #fff0 70%, #1d1d1d 100%),
    url(${___CSS_LOADER_URL_REPLACEMENT_80___}) no-repeat 0 0;
  background-size: 100% auto;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.2), 0px 0px 50px rgba(0, 0, 0, 0.2);
}
.bg-smartemr {
  background: linear-gradient(#fff0 0%, #fff0 70%, #1d1d1d 100%),
    url(${___CSS_LOADER_URL_REPLACEMENT_81___}) no-repeat 0 0;
  background-size: 100% 100%;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.2), 0px 0px 50px rgba(0, 0, 0, 0.2);
}
.bg-processauto {
  background: linear-gradient(#fff0 0%, #fff0 70%, #1d1d1d 100%),
    url(${___CSS_LOADER_URL_REPLACEMENT_82___}) no-repeat 0 0;
  background-size: 100% 100%;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.2), 0px 0px 50px rgba(0, 0, 0, 0.2);
}

button.carousel-arrow:hover {
  box-shadow: none !important;
}
.about-map-img {
  width: 80%;
  height: 70vh;
  background-size: contain;
  z-index: 1;
  margin: auto;
  margin-bottom: 0 !important;
}
.chat-widget {
  width: 100%;
  height: 70vh;
  overflow: hidden;
}
.custom-questionnaire {
  margin-bottom: 10em;
  display: flex;
  justify-content: center;
  color: white;
  margin: 0 0.5em;
  padding-top: 4em;
  overflow: hidden;
  box-sizing: border-box;
  /* max-height: 80vh; */
  /* overflow-y: hidden; */

  height: calc(100% - 4em);
  position: relative;
  /* z-index: 100; */
}
.MuiStepLabel-root .MuiStepLabel-labelContainer {
  color: white;
}
.MuiStepLabel-root .MuiStepLabel-labelContainer .Mui-active {
  color: white;
  font-size: 1.3em;
  font-weight: 600;
}

.MuiStepLabel-root .MuiStepLabel-labelContainer .Mui-active > p:nth-child(2) {
  font-size: 0.85em;
  font-weight: 100;
}

.MuiStepLabel-root .MuiStepLabel-labelContainer .Mui-active > a {
  text-decoration: none;
  color: white;
  font-weight: 600;
}

.MuiStepLabel-root .MuiStepLabel-labelContainer .Mui-completed {
  color: white;
  font-size: 1.1em;
  font-weight: 600;
  cursor: pointer;
}
.nextChoice-container {
  line-height: 1.6em;
  padding: 0.75em 1.75em;
  background-color: #333;
  border: 1px solid #777;
  margin-bottom: 1em;
  border-radius: 0.5em;
  cursor: pointer;
  color: white;
  transition: all 0.7s ease-in-out;
}

.nextChoice-container > div > div {
  line-height: 1.4em;
  font-size: 0.9em;
}
.nextChoice-container:hover {
  background-color: #fff;
  color: black;
}
.MuiButton-root {
  width: 23%;
  margin: 2em !important;
}
.thanksyou-wrapper {
  display: flex;
  width: 42vw;
  text-align: center;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 20em;
}
/* .carousel-item[data-carouselkey="0"]{
    transform: translateX(0px) translateX(250px) translateX(0px) !important;
  }
  .carousel-item[data-carouselkey="1"]{
    transform: translateX(0px) translateX(450px) !important;
  }
  .carousel-item[data-carouselkey="1"]{
    transform: translateX(0px) translateX(-736px) !important;
  } */

.masonry-container {
  column-count: 3;
  column-gap: 1.5em;
  width: 100%;
  /* margin-left: -5%; */
}

.masonry-item {
  display: inline-block;
  width: 100%;
  /* transform: translate(0, 200px);  */
  opacity: 0;
}

/* .masonry-item img:hover {
  transform: scale(1.03);
  border-radius: 5px;
} */
.masonry-item img {
  display: block;
  width: 100%;
  cursor: pointer;
  transition: transform 0.5s ease-in-out;
  border-radius: 5px;
}
.masonry-container > .masonry-item {
  transition: all 0.7s ease-in-out;
  /* transition-delay: 0ms !important; */
}

/* Just for decoration: */
.masonry-item span {
  font-family: sans-serif;
  display: block;
  padding: 0.25em;
  position: absolute;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: left;
}

.masonry-item {
  margin-bottom: 1.2em;

  border-radius: 5px;
  position: relative;
}
.user-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_83___}) no-repeat;
}

.user-box {
  width: 100%;
  background: #131313 url(${___CSS_LOADER_URL_REPLACEMENT_83___}) no-repeat 3% 43%;
  background-size: auto 40%;
  color: #fff;
  border: 1px solid #eee;
  border-radius: 0.5em;
  line-height: 3em;
  height: 3.5em;
  box-sizing: border-box;
  padding-left: 4em;
  margin: 0.5em;
  outline: none;
}
.user-box::placeholder {
  padding-left: 0em;
}
.user-box:focus::-webkit-input-placeholder {
  opacity: 0;
}

.email-box {
  width: 100%;
  background: #131313 url(${___CSS_LOADER_URL_REPLACEMENT_84___}) no-repeat 3% 43%;
  background-size: auto 40%;
  color: #fff;
  border: 1px solid #eee;
  border-radius: 0.5em;
  line-height: 3em;
  height: 3.5em;
  box-sizing: border-box;
  padding-left: 4em;
  margin: 0.5em;
  outline: none;
}

.email-box::placeholder {
  padding-left: 0em;
}
.email-box:focus {
  outline: none;
}
.email-box:focus::-webkit-input-placeholder {
  opacity: 0;
}
.email-submit {
  margin-top: 0;
  line-height: 1;
  width: 100%;
  height: 2.5em;
  margin: 0.5em;
  color: #161616;
  box-sizing: border-box;
  display: none;
  padding: 0;
  background: #eee url(${___CSS_LOADER_URL_REPLACEMENT_85___}) no-repeat 39% 57%;
  background-size: auto 50%;
  border-radius: 0.5em;
  font-weight: 700;
}
.active {
  display: block;
}

.say-hi-class {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  background: #131313;
  color: #fff;
  width: 93%;
  margin: 1em 0em 0em 0.3em;
  outline: none;
  border-radius: 0.5em;
  border: 1px solid #eee;
  padding: 2.5%;
}

.say-hi-class::placeholder {
  color: #fff;
  opacity: 0.5;
  line-height: -5em;
}
.wrappper {
  overflow-y: scroll;
}
.scrollable-div {
  /* height: 150vh; */
}
.allow-scroll {
  overflow: hidden;
}
.about-black {
  background-color: #000;
}
.overlay {
  width: 100vw;
  height: 100vh;
  background: black;
  opacity: 0.7;
  position: fixed;
  top: 0em;
  left: 0em;
}
.thankyou-font {
  font-size: 3em;
  bottom: 100%;
}
.MuiBox-root {
  width: 42vw;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
  overflow-x: hidden;
}
.MuiBox-root .MuiBox-root {
  width: 100%;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.MuiBox-root::-webkit-scrollbar {
  display: none;
}

span.MuiStepLabel-vertical {
  padding: 0.75em 0;
}
span.MuiStepLabel-root {
  align-items: flex-start;
  -webkit-box-align: start;
}
span.MuiStepLabel-iconContainer {
  padding-top: 0.1em;
}
.nextChoice-container h5 {
  font-size: 1.1em;
  padding-bottom: 0.5em;
}
.active-menu {
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 0.2em;
  font-weight: 600 !important;
  background: linear-gradient(90deg, #ffde31 5.31%, #ff3db2 79.42%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  /* for border */
  border-bottom: 3px solid transparent;
  /* border-image: linear-gradient(90deg, #ffde31 5.31%, #ff3db2 79.42%); */
  border-image-slice: 1;
}
.mailbox {
  padding: 2.5em 2% 2.5em 3% !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_86___}) no-repeat 0% 50%;
  cursor: pointer;
  text-decoration: none;
  color: #fff;
}
.mailbox-nomail {
  cursor: pointer;
  text-decoration: none;
  color: #fff;
}
.lazy-load-image-background {
  overflow: hidden;
}
.lazy-images-odd {
  width: auto;
  height: 100vh;
  object-fit: cover;
}

.lazy-images-even {
  width: auto;
  /* margin-left: -52%; */
  height: 100vh;
  object-fit: cover;
}

.fleetimg {
  width: 152%;
  margin-left: -52%;
}

#pandemic .lazy-images-odd,
.ehr .lazy-images-odd {
  /* width: 110%; */
}
.fleet img {
  height: 100vh;
  width: auto;
  margin-left: -35%;
}
.fleet .picarroimg {
  margin-left: 0%;
  margin-top: -6%;

  height: 100vh;
  margin: 0;
}
.ehr img {
  margin-left: -10%;
}
.gta img {
  height: 100vh;

  margin-left: 0;
}

#mouse-circle {
  position: absolute;
  width: 50px;
  height: 50px;
  margin: -32px 0px 0px -32px;
  pointer-events: none !important;
  /* border-image-source: linear-gradient(90deg, #ffde31 47.31%, #ff3db2 52.42%); */
  box-shadow: 0 0 16px rgba(255, 255, 255, 0);
  /* for smooth scaling */
  transition: transform 0.2s ease-in-out;
  /* border: 2px solid #fff; */
  border-radius: 50%;
  border-radius: 50px; /*1*/
  border: 1.5px solid transparent;
  background: linear-gradient(45deg, #ffde31, #ff3db2) border-box; /*3*/
  -webkit-mask: /*4*/ linear-gradient(#fff 0 0) padding-box,
    linear-gradient(#fff 0 0); /*5'*/
  mask-composite: exclude; /*5*/
}

.scroll-down {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.ul {
  display: block;
  padding-inline-start: 1.5rem;
  list-style: disc;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.web.css"],"names":[],"mappings":"AAAA,4EAA4E;;AAE5E,2EAA2E;AAC3E;;;;EAIE;;AAEF;;+EAE+E;AAC/E;EACE,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C;;;;8DAI4D;EAC5D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4CAA2C;EAC3C;;;;8DAI2D;EAC3D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAAkD;EAClD;;;;;+DAKkE;EAClE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAAmD;EACnD;;;;;+DAKmE;EACnE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAAkD;EAClD;;;;;+DAKkE;EAClE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA+C;EAC/C;;;;;+DAK+D;EAC/D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA4C;EAC5C;;;;+DAI4D;EAC5D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C;;;;+DAI6D;EAC7D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAAoD;EACpD;;;;;+DAKoE;EACpE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAAiD;EACjD;;;;;+DAKiE;EACjE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA2C;EAC3C;;;;+DAI2D;EAC3D,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAA8C;EAC9C;;;;+DAI8D;EAC9D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAAqD;EACrD;;;;;+DAKqE;EACrE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,6CAAiD;EACjD;;;;;+DAKiE;EACjE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,+EAAsE;EACtE,0BAA0B;EAC1B,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;;;;;;;;GAQG;AACH;;;;;;GAMG;;AAEH;;;;;;;;;;;GAWG;;AAEH;;;;;;;;EAQE;;AAOF;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE;;AAEF;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,aAAa;EACb,UAAU;AACZ;;AAEA;;;;EAIE;;AAEF;;;;;;EAME,sBAAsB;AACxB;;AAEA;;EAEE;;AAEF;EACE,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE;;AAEF;EACE,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E;;+EAE+E;;AAE/E;;EAEE;;AAEF;;EAEE,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE;;AAEF;EACE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,MAAM;AACR;;AAEA;;;;EAIE;;AAEF;;EAEE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE;;AAEF;EACE,kBAAkB;AACpB;;AAEA;;;;;;;;;;EAUE;;AAEF;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;+EAI+E;;AAE/E;EACE,4DAA4D;AAC9D;;AAEA;;;EAIE,kDAAkD;AACpD;;AAEA;;;;+EAI+E;;AAE/E;EACE;;;IAGE,2BAA2B;IAC3B,sBAAsB;IACtB,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE;EACF;;IAEE,WAAW;EACb;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;;;IAGE;EACF;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;;IAGE,UAAU;IACV,SAAS;EACX;;EAEA;;IAEE,uBAAuB;EACzB;AACF;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;AACb;AACA,cAAc;AACd;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kFAAkF;EAClF,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;EACE,iBAAiB;EACjB;qEACmE;EACnE,gEAAgE;EAChE,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,oCAAoC;EACpC;yCACuC;AACzC;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA,aAAa;AACb,cAAc;;AAEd;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,UAAU;;EAEV,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,mBAAmB;;EAEnB,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,UAAU;EACV,sCAAsC;AACxC;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,+BAA+B;EAC/B,aAAa;EACb,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,sCAAsC;EACtC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oEAA6D;EAC7D,oBAAoB;AACtB;AACA;EACE,oEAA2D;EAC3D,oBAAoB;AACtB;AACA;EACE,oEAA6D;EAC7D,oBAAoB;AACtB;AACA;EACE,oEAA0D;EAC1D,oBAAoB;AACtB;AACA;EACE,oEAAwD;EACxD,oBAAoB;AACtB;AACA;EACE,oEAAsD;EACtD,oBAAoB;AACtB;AACA;EACE,oEAA0D;EAC1D,oBAAoB;AACtB;AACA;;;;;;;GAOG;AACH;EACE,UAAU;;EAEV,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mEAAmE;EACnE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,+BAA+B;EAC/B,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,SAAS;AACX;AACA;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;AAEH;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,0DAA0D;EAC1D,wDAAwD;EACxD,yDAAyD;EACzD,eAAe;EACf,YAAY;AACd;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;;EAEE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;GAEG;AACH;EACE,aAAa;AACf;AACA;EACE,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kEAA0D;EAC1D,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;;GAEG;AACH;EACE;;GAEC,EAAE,qFAAqF;AAC1F;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,uCAAuC;EACzC;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,uCAAuC;EACzC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;EAClC;EACA;IACE,wBAAwB;;IAExB,kBAAkB;EACpB;EACA;IACE,UAAU;IAEV,gCAAgC;IAChC,6BAA6B;EAC/B;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE;MACE,aAAa;IACf;EACF;AACF;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;;AAEA,aAAa;;AAEb;EACE,YAAY;EACZ,kFAAkF;EAClF,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE;IACE,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX;;sDAEkD;IAClD,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX;;sDAEkD;IAClD,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iEAAiE;EACjE,2EAA2E;EAC3E,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAET,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;KAOK;AACL;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,8BAA8B;EAC9B,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EAET,gCAAgC;EAChC,sCAAsC;EACtC,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EAEE,gCAAgC;EAChC,UAAU;EACV,mCAAmC;EACnC,iCAAiC;EACjC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;AAClB;AACA,mCAAmC;AACnC;EACE,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,iCAAiC;EACjC,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,sCAAsC;AACxC;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE,uFAAuF;EACvF,6BAA6B;EAC7B,2CAA2C;EAC3C,iCAAiC;EACjC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC;qBACmB;AACrB;AACA;EACE;4CAC0C;EAC1C,6BAA6B;EAC7B,iCAAiC;EACjC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gFAAmF;EACnF,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB;;qBAEmB;AACrB;AACA;EACE,kFAAkF;EAClF,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;;EAEhB,2CAA2C;EAC3C;qBACmB;AACrB;AACA;EACE,0FAA0F;EAC1F,8BAA8B;EAC9B,2CAA2C;EAC3C,kCAAkC;EAClC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mFAAmF;EACnF,6BAA6B;EAC7B,2CAA2C;EAC3C,iCAAiC;EACjC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,kCAAkC;IAClC,UAAU;EACZ;;EAEA;IACE,+BAA+B;IAC/B,UAAU;EACZ;AACF;AACA;EACE,+DAA+D;EAC/D,qBAAqB;EACrB,6BAA6B;EAC7B,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,kEAAkE;EAClE,kCAAkC;EAClC,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,kEAAkE;EAClE,kCAAkC;EAClC,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,YAAY;AACd;;AAEA;;EAEE,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;0DACmD;EACnD,0BAA0B;EAC1B,2EAA2E;AAC7E;AACA;EACE;0DAC0C;EAC1C,0BAA0B;EAC1B,2EAA2E;AAC7E;AACA;EACE;0DACwD;EACxD,0BAA0B;EAC1B,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,UAAU;EACV,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;;EAExB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;;;;;;;;KAQK;;AAEL;EAGE,eAAe;EAIf,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,qCAAqC;EACrC,UAAU;AACZ;;AAEA;;;GAGG;AACH;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;;EAEpB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,8DAAiD;AACnD;;AAEA;EACE,WAAW;EACX,6EAAgE;EAChE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,6EAAgE;EAChE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,UAAU;EACV,2EAA+D;EAC/D,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,uDAAuD;EACvD,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,SAAS;AACX;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;EACX,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,iEAAiE;EACjE,6BAA6B;EAC7B,oCAAoC;EACpC,eAAe;EACf,oCAAoC;EACpC,yEAAyE;EACzE,qBAAqB;AACvB;AACA;EACE,qCAAqC;EACrC,qEAA+D;EAC/D,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;;EAEf,aAAa;EACb,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;;EAEb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,+BAA+B;EAC/B,iFAAiF;EACjF,2CAA2C;EAC3C,uBAAuB;EACvB,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB,EAAE,IAAI;EACzB,+BAA+B;EAC/B,+DAA+D,EAAE,IAAI;EACrE;6BAC2B,EACE,KAAK;EAClC,uBAAuB,EAAE,IAAI;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB","sourcesContent":["/*! HTML5 Boilerplate v8.0.0 | MIT License | https://html5boilerplate.com/ */\n\n/* main.css 2.1.0 | MIT License | https://github.com/h5bp/main.css#readme */\n/*\n * What follows is the result of much research on cross-browser styling.\n * Credit left inline and big thanks to Nicolas Gallagher, Jonathan Neal,\n * Kroc Camen, and the H5BP dev community and team.\n */\n\n/* ==========================================================================\n   Base styles: opinionated defaults\n   ========================================================================== */\nbody::-webkit-scrollbar {\n  width: 0;\n}\n\n* {\n  padding: 0;\n  margin: 0;\n}\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-Light.eot\");\n  src: local(\"Calibre Light\"), local(\"Calibre-Light\"),\n    url(\"../assets/font/Calibre-Light.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-Light.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-Light.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-Light.ttf\") format(\"truetype\");\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-Thin.eot\");\n  src: local(\"Calibre Thin\"), local(\"Calibre-Thin\"),\n    url(\"../assets/font/Calibre-Thin.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-Thin.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-Thin.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-Thin.ttf\") format(\"truetype\");\n  font-weight: 100;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-LightItalic.eot\");\n  src: local(\"Calibre Light Italic\"), local(\"Calibre-LightItalic\"),\n    url(\"../assets/font/Calibre-LightItalic.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-LightItalic.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-LightItalic.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-LightItalic.ttf\") format(\"truetype\");\n  font-weight: 300;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-MediumItalic.eot\");\n  src: local(\"Calibre Medium Italic\"), local(\"Calibre-MediumItalic\"),\n    url(\"../assets/font/Calibre-MediumItalic.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-MediumItalic.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-MediumItalic.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-MediumItalic.ttf\") format(\"truetype\");\n  font-weight: 500;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-BlackItalic.eot\");\n  src: local(\"Calibre Black Italic\"), local(\"Calibre-BlackItalic\"),\n    url(\"../assets/font/Calibre-BlackItalic.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-BlackItalic.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-BlackItalic.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-BlackItalic.ttf\") format(\"truetype\");\n  font-weight: 900;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-Semibold.eot\");\n  src: local(\"Calibre Semibold\"), local(\"Calibre-Semibold\"),\n    url(\"../assets/font/Calibre-Semibold.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-Semibold.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-Semibold.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-Semibold.ttf\") format(\"truetype\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-Black.eot\");\n  src: local(\"Calibre Black\"), local(\"Calibre-Black\"),\n    url(\"../assets/font/Calibre-Black.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-Black.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-Black.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-Black.ttf\") format(\"truetype\");\n  font-weight: 900;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-Medium.eot\");\n  src: local(\"Calibre Medium\"), local(\"Calibre-Medium\"),\n    url(\"../assets/font/Calibre-Medium.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-Medium.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-Medium.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-Medium.ttf\") format(\"truetype\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-RegularItalic.eot\");\n  src: local(\"Calibre Regular Italic\"), local(\"Calibre-RegularItalic\"),\n    url(\"../assets/font/Calibre-RegularItalic.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-RegularItalic.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-RegularItalic.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-RegularItalic.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-BoldItalic.eot\");\n  src: local(\"Calibre Bold Italic\"), local(\"Calibre-BoldItalic\"),\n    url(\"../assets/font/Calibre-BoldItalic.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-BoldItalic.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-BoldItalic.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-BoldItalic.ttf\") format(\"truetype\");\n  font-weight: bold;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-Bold.eot\");\n  src: local(\"Calibre Bold\"), local(\"Calibre-Bold\"),\n    url(\"../assets/font/Calibre-Bold.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-Bold.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-Bold.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-Bold.ttf\") format(\"truetype\");\n  font-weight: bold;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-Regular.eot\");\n  src: local(\"Calibre\"), local(\"Calibre-Regular\"),\n    url(\"../assets/font/Calibre-Regular.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-Regular.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-Regular.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-SemiboldItalic.eot\");\n  src: local(\"Calibre Semibold Italic\"), local(\"Calibre-SemiboldItalic\"),\n    url(\"../assets/font/Calibre-SemiboldItalic.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-SemiboldItalic.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-SemiboldItalic.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-SemiboldItalic.ttf\") format(\"truetype\");\n  font-weight: 600;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Calibre\";\n  src: url(\"../assets/font/Calibre-ThinItalic.eot\");\n  src: local(\"Calibre Thin Italic\"), local(\"Calibre-ThinItalic\"),\n    url(\"../assets/font/Calibre-ThinItalic.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../assets/font/Calibre-ThinItalic.woff2\") format(\"woff2\"),\n    url(\"../assets/font/Calibre-ThinItalic.woff\") format(\"woff\"),\n    url(\"../assets/font/Calibre-ThinItalic.ttf\") format(\"truetype\");\n  font-weight: 100;\n  font-style: italic;\n}\n\nhtml {\n  color: #222;\n  font-size: 1.2em;\n  line-height: 1.4;\n  font-family: \"Calibre\", sans-serif;\n  font-weight: 300;\n  background-color: #131313;\n  overflow: hidden;\n}\n#root {\n  overflow: hidden;\n  /* overflow-y: scroll; */\n  /* position: relative; */\n}\n#root::before {\n  content: \"\";\n  position: fixed;\n  width: 200%;\n  height: 200%;\n  top: -50%;\n  left: -50%;\n  z-index: -1;\n  background: #131313 url(../assets/img/line_bg1.svg) no-repeat 73% 20vh;\n  transform: rotate(-270deg);\n  -webkit-transition: all 1s linear;\n  background-size: 35%;\n}\n#root.magic-root-before::before {\n  /* left:-70%; */\n}\n/* -webkit-transition: all 1s ease-in;\n}\n#root.magic-root-before::before{\n  transform: rotate(90deg);\n  left:-80%;\n  top:-30%;\n  \n  \n} */\n/* #root.magic-root-before2::before{\n  transform: rotate(-30deg);\n  left:-40%;\n  top:-50%;\n  \n  \n} */\n\n/* .white-bg.black-rhombuz::before{\n  content: \"\";\n  position: fixed;\n  width: 200%;\n  height: 200%;\n  top: -50%;\n  left: -50%;\n  z-index: -1; \n  background: #fff url(../assets/img/line_bg1_black.svg) no-repeat 50% 50vh;\n  transform: rotate(0deg);\n  -webkit-transition: all 1s ease-in;\n} */\n\n/*\n * Remove text-shadow in selection highlight:\n * https://twitter.com/miketaylr/status/12228805301\n *\n * Vendor-prefixed and regular ::selection selectors cannot be combined:\n * https://stackoverflow.com/a/16982510/7133471\n *\n * Customize the background color to match your design.\n */\n\n::-moz-selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\n::selection {\n  background: #b3d4fc;\n  text-shadow: none;\n}\n\n/*\n * A better looking default horizontal rule\n */\n\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid #ccc;\n  margin: 1em 0;\n  padding: 0;\n}\n\n/*\n * Remove the gap between audio, canvas, iframes,\n * images, videos and the bottom of their containers:\n * https://github.com/h5bp/html5-boilerplate/issues/440\n */\n\naudio,\ncanvas,\niframe,\nimg,\nsvg,\nvideo {\n  vertical-align: middle;\n}\n\n/*\n * Remove default fieldset styles.\n */\n\nfieldset {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\n/*\n * Allow only vertical resizing of textareas.\n */\n\ntextarea {\n  resize: vertical;\n}\n\n/* ==========================================================================\n   Author's custom styles\n   ========================================================================== */\n\n/* ==========================================================================\n   Helper classes\n   ========================================================================== */\n\n/*\n * Hide visually and from screen readers\n */\n\n.hidden,\n[hidden] {\n  display: none !important;\n}\n\n/*\n * Hide only visually, but have it available for screen readers:\n * https://snook.ca/archives/html_and_css/hiding-content-for-accessibility\n *\n * 1. For long content, line feeds are not interpreted as spaces and small width\n *    causes content to wrap 1 word per line:\n *    https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe\n */\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n  /* 1 */\n}\n\n/*\n * Extends the .sr-only class to allow the element\n * to be focusable when navigated to via the keyboard:\n * https://www.drupal.org/node/897638\n */\n\n.sr-only.focusable:active,\n.sr-only.focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  white-space: inherit;\n  width: auto;\n}\n\n/*\n * Hide visually and from screen readers, but maintain layout\n */\n\n.invisible {\n  visibility: hidden;\n}\n\n/*\n * Clearfix: contain floats\n *\n * For modern browsers\n * 1. The space content is one way to avoid an Opera bug when the\n *    `contenteditable` attribute is included anywhere else in the document.\n *    Otherwise it causes space to appear at the top and bottom of elements\n *    that receive the `clearfix` class.\n * 2. The use of `table` rather than `block` is only necessary if using\n *    `:before` to contain the top-margins of child elements.\n */\n\n.clearfix::before,\n.clearfix::after {\n  content: \" \";\n  display: table;\n}\n\n.clearfix::after {\n  clear: both;\n}\n\n/* ==========================================================================\n   EXAMPLE Media Queries for Responsive Design.\n   These examples override the primary ('mobile first') styles.\n   Modify as content requires.\n   ========================================================================== */\n\n@media only screen and (min-width: 35em) {\n  /* Style adjustments for viewports that meet the condition */\n}\n\n@media print,\n  (-webkit-min-device-pixel-ratio: 1.25),\n  (min-resolution: 1.25dppx),\n  (min-resolution: 120dpi) {\n  /* Style adjustments for high resolution devices */\n}\n\n/* ==========================================================================\n   Print styles.\n   Inlined to avoid the additional HTTP request:\n   https://www.phpied.com/delay-loading-your-print-css/\n   ========================================================================== */\n\n@media print {\n  *,\n  *::before,\n  *::after {\n    background: #fff !important;\n    color: #000 !important;\n    /* Black prints faster */\n    box-shadow: none !important;\n    text-shadow: none !important;\n  }\n\n  a,\n  a:visited {\n    text-decoration: underline;\n  }\n\n  a[href]::after {\n    content: \" (\" attr(href) \")\";\n  }\n\n  abbr[title]::after {\n    content: \" (\" attr(title) \")\";\n  }\n\n  /*\n   * Don't show links that are fragment identifiers,\n   * or use the `javascript:` pseudo protocol\n   */\n  a[href^=\"#\"]::after,\n  a[href^=\"javascript:\"]::after {\n    content: \"\";\n  }\n\n  pre {\n    white-space: pre-wrap !important;\n  }\n\n  pre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid;\n  }\n\n  /*\n   * Printing Tables:\n   * https://web.archive.org/web/20180815150934/http://css-discuss.incutio.com/wiki/Printing_Tables\n   */\n  thead {\n    display: table-header-group;\n  }\n\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n}\nh1 {\n  font-size: 6.5em;\n  font-weight: normal;\n}\nh2 {\n  font-size: 3.8em;\n}\nh3 {\n  font-size: 2em;\n  line-height: 1.1em;\n  font-weight: 300;\n  margin-block-start: 0;\n}\n.bold {\n  font-weight: bold;\n}\nh4 {\n  font-size: 1.5em;\n  font-weight: normal;\n  margin-block-start: 0;\n}\nh5 {\n  font-size: 1.1em;\n}\nul {\n  padding-inline-start: 0;\n  list-style: none;\n  display: flex;\n}\n\n.fullpage {\n  height: 100vh;\n  width: 100%;\n}\n/*Home Header*/\n.banner {\n  color: #fff;\n  box-sizing: border-box;\n  position: relative;\n  /* background: #131313 url(\"../assets/img/bg_hero_banner@3x.png\") no-repeat 0 0; */\n  background-size: contain;\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n}\n.banner .title-header {\n  position: absolute;\n  top: 50%;\n  width: 100%;\n}\n.banner h1 {\n  margin-left: 8.7%;\n  /* background: 50% 100% / 50% 50% no-repeat\n              radial-gradient(ellipse at bottom, #fff, #fff, #fff); */\n  background: radial-gradient(ellipse at bottom, #fff, #fff, #fff);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  font-size: 6em;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600;\n  animation: glow 2500ms linear 2000ms;\n  /* animation: reveal 3000ms ease-in-out forwards 200ms,\n             glow 2500ms linear 2000ms; */\n}\n@keyframes reveal {\n  80% {\n    letter-spacing: 8px;\n  }\n  100% {\n    background-size: 300% 300%;\n  }\n}\n@keyframes glow {\n  40% {\n    text-shadow: 0 0 8px #fff;\n  }\n}\n\n.banner .fusion {\n  margin-left: 9.1%;\n  font-size: 1.4em;\n  width: 70vw;\n}\n\n/*Header End*/\n/*List Styles*/\n\n.nav li {\n  flex: 0 1 auto;\n  flex-basis: auto;\n  margin-right: 3em;\n  box-sizing: content-box;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 1.8em;\n}\n.nav.fusion li {\n  cursor: auto;\n  margin-top: -1em;\n}\n\n/*List Styles Ends*/\n\n.flex-row {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  width: 100%;\n  justify-content: flex-end;\n}\n.content-section {\n  width: 75%;\n  padding-top: 3em;\n  margin: auto;\n  text-align: center;\n  box-sizing: border-box;\n  color: #131313;\n}\n.scalable > .content-section {\n  color: #fff;\n  margin: 4em auto 4em;\n  padding-top: 1em;\n}\n.scalable > .content-section > h3 {\n  margin-bottom: 1.5em;\n}\n.content-section > div {\n  margin-bottom: 3.5%;\n  font-size: 1.2em;\n}\n.flex-row > div {\n  padding-top: 12%;\n  width: 50%;\n\n  /* margin-right: 10%; */\n  vertical-align: top;\n  box-sizing: border-box;\n}\n.magic-section {\n  height: 100%;\n  position: absolute;\n  left: 0;\n  z-index: 5;\n  padding-bottom: 10%;\n\n  background-size: auto 160%;\n  color: #ccc;\n}\n.magic-section h3 {\n  padding: 0 18%;\n  transform: translate(-20%, -5px);\n  opacity: 0;\n  -webkit-transition: all 1s ease-in-out;\n}\n.top-pad-header {\n  padding-top: 8%;\n}\n.hiring-top {\n  padding-top: 20%;\n}\n.black-bg {\n  background-color: #131313;\n}\n.white-bg {\n  background-color: #fff;\n}\n.magic-content {\n  padding-right: 10.5% !important;\n  height: 100vh;\n  opacity: 0;\n  color: #fff;\n  transform: translate(20%, 0px);\n  -webkit-transition: all 1s ease-in-out;\n  /* -webkit-transition-delay: 0.8s; */\n  font-size: 1.2em;\n  line-height: 1.6em;\n}\n\n.magic-content b {\n  font-weight: 800;\n}\n.magic-section b {\n  font-weight: 600;\n  color: #fff;\n}\nh3 b {\n  font-weight: 600;\n}\n.relative {\n  position: relative;\n}\n.contactus-form {\n  width: 98%;\n  top: -0.2em;\n}\n.impact li {\n  padding-top: 5em;\n  margin-top: 2em;\n  margin-right: 2vw;\n  margin-left: 2vw;\n  text-align: center;\n  width: 25%;\n  box-sizing: border-box;\n  font-size: 1em;\n}\n.impact li p {\n  padding: 0 0.6em;\n}\n\n.impact-solve li {\n  width: 33%;\n}\n\n.impact li h6 {\n  padding-bottom: 2vh;\n  font-weight: bold;\n  font-size: 1.2em;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n.etools {\n  background: url(../assets/img/enterprize.svg) no-repeat 50% 0;\n  background-size: 17%;\n}\n.capps {\n  background: url(../assets/img/consumer.svg) no-repeat 50% 0;\n  background-size: 16%;\n}\n.pauto {\n  background: url(../assets/img/automation.svg) no-repeat 50% 0;\n  background-size: 17%;\n}\n.monitor {\n  background: url(../assets/img/monitor.svg) no-repeat 50% 0;\n  background-size: 17%;\n}\n.solve {\n  background: url(../assets/img/solve.svg) no-repeat 50% 0;\n  background-size: 18%;\n}\n.bvb {\n  background: url(../assets/img/bvb.svg) no-repeat 50% 0;\n  background-size: 18%;\n}\n.reality {\n  background: url(../assets/img/reality.svg) no-repeat 50% 0;\n  background-size: 16%;\n}\n/* .moving-white{\n  height: 95vh;\n  position: absolute;\n  width:50%;\n  right:0;\n  z-index: 1;\n  background: #fff;\n} */\n.movable {\n  width: 70%;\n\n  margin: auto;\n  z-index: 5;\n  position: relative;\n}\n.impact.movable {\n  width: 120%;\n  margin-left: -10%;\n}\n.scalablebg {\n  background: #131313;\n  height: auto;\n}\n.scalable {\n  width: 100vw;\n  color: #fff;\n  position: sticky;\n  top: 5em;\n}\n.scalable-movable {\n  position: absolute;\n  height: 110%;\n  background-color: #131313;\n  width: 50%;\n  z-index: -1;\n}\n.carousel-container {\n  width: 80vw;\n  position: relative;\n  left: -8.5vw;\n  box-sizing: border-box;\n  /* overflow-x: scroll; */\n  height: 50vh;\n  margin-top: 10vh;\n}\n.only-tiles {\n  display: flex;\n  flex-direction: row;\n}\n.only-tiles > div {\n  width: 33%;\n  margin: 0 3em;\n  box-sizing: border-box;\n  -webkit-transition: all 0.6s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  cursor: pointer;\n}\n.only-tiles > div > div {\n  border-radius: 1em;\n  filter: grayscale(0.2);\n  -webkit-transition: all 1s ease-in;\n}\n.only-tiles > div > div:hover {\n  filter: grayscale(0);\n}\n.only-tiles > div:hover {\n  transform: scale(1.2);\n}\n\n.carousel {\n  width: 150vw;\n  margin: 0 20%;\n  display: flex;\n}\n\n@keyframes translateX {\n  0% {\n    transform: translate(5000px, 0);\n  }\n  100% {\n    transform: translate(0px, 0);\n  }\n}\n.carousel div {\n  width: 26vw;\n  margin: 0.5em 1.5em;\n  height: 45vh;\n  overflow: hidden;\n  position: relative;\n}\n.carousel div > p {\n  position: absolute;\n  z-index: 1;\n  top: 25%;\n  font-weight: 500;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.35);\n  left: 0px;\n  padding: 0 20px;\n  font-size: 1.5em;\n}\n.carousel div > p:nth-child(2) {\n  position: absolute;\n  z-index: 1;\n  top: calc(25% + 1.38em);\n  left: 7%;\n}\n.carousel div > p:nth-child(3) {\n  position: absolute;\n  z-index: 1;\n  top: 80%;\n  font-size: 0.75em;\n  cursor: pointer;\n  background: rgba(10, 10, 10, 0.75);\n  left: 0px;\n}\n/* .carousel .cmp1{\n  \n  animation: translateX 2s;\n  animation-delay: 1s;\n  animation-timing-function: ease-in-out;\n}\n.carousel .cmp2{\n  \n  animation: translateX 3s;\n  animation-delay: 2s;\n  animation-timing-function: ease-in-out;\n}\n.carousel .cmp3{\n \n  animation: translateX 4s;\n  animation-delay: 3s;\n  animation-timing-function: ease-in-out;\n}\n.carousel .cmp4{\n  \n  animation: translateX 5s;\n  animation-delay: 4s;\n  animation-timing-function: ease-in-out;\n} */\n\n.carousel img {\n  width: 100%;\n}\nbutton {\n  margin-top: 4em;\n  background: #131313;\n  color: #fff;\n  font-size: 1em;\n  font-weight: 400;\n  line-height: 4em;\n  padding: 0 10vw;\n  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  -moz-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  -o-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  -ms-transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  cursor: pointer;\n  border: none;\n}\nbutton:hover {\n  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);\n}\n.margintop5 {\n  margin-top: 2.5em;\n}\n\nfooter {\n  width: 100%;\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n}\n.footer-contact {\n  width: 81.5%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.75em;\n}\n.footer-contact div {\n  padding: 2.5em 0;\n}\n\n.content {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin: auto;\n  height: 17rem;\n  position: relative;\n  justify-content: flex-start;\n  align-items: center;\n  cursor: pointer;\n  z-index: 10;\n}\n#slider,\n#slider2 {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  display: flex;\n  flex-direction: column-reverse;\n  position: relative;\n  vertical-align: middle;\n}\n\n.content img {\n  width: auto;\n  max-width: 75%;\n  height: 90%;\n  right: 0;\n  position: absolute;\n}\n.content p {\n  margin-left: 25%;\n  z-index: 1;\n  position: relative;\n  margin-bottom: 50%;\n  font-weight: 600;\n}\n.content p:nth-child(2) {\n  margin-left: 18%;\n  margin-bottom: 0%;\n}\n.movable-parallax-1 {\n  margin-top: 37em;\n}\n/* .movable-parallax-1-{\n  margin-top: -22em;\n} */\n#scroll-horizontal {\n  height: 150vw;\n}\n.listening-triangle {\n  width: 0;\n  height: 0;\n  border: 0 solid transparent;\n  border-right-width: 100vw;\n  border-left-width: 0vw;\n  border-top: 7em solid #f3f3f3;\n  position: absolute;\n  top: 5em;\n  left: -16.5%;\n  margin-bottom: 0px !important;\n}\n.announcement {\n  position: absolute;\n  margin-left: 50%;\n  background: url(../assets/img/handshake.png) no-repeat 0 0;\n  background-size: 100%;\n  width: 7em;\n  height: 7em;\n  left: -3.5em;\n  top: 4em;\n  margin-bottom: 0px !important;\n  transition: transform 0.2s;\n}\n/* .announcement:hover{\n  transform: scale(1.2); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) \n} */\nnav > .nav > li:hover {\n  transform: scale(\n    1.1\n  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */\n}\n.announcemnet-cover {\n  background-color: #f3f3f3;\n  height: 5em;\n  width: 100vw;\n  left: -16.5%;\n  position: absolute;\n  top: 0;\n}\n\n.grey {\n  background-color: #f3f3f3;\n  display: inline-block;\n  position: relative;\n  height: 100vh;\n  width: 100vw;\n}\n@media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) and (hover: none) {\n  .grey {\n    max-height: 800px;\n  }\n  .wowhide {\n    opacity: 1 !important;\n    transform: translate(0, 0px) !important;\n  }\n  .hiring-top {\n    padding-top: 25%;\n  }\n}\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1) {\n  .grey {\n    max-height: 800px;\n  }\n  .wowhide {\n    opacity: 1 !important;\n    transform: translate(0, 0px) !important;\n  }\n  .hiring-top {\n    padding-top: 25%;\n  }\n  nav {\n    padding: 2em !important;\n  }\n  .nav li {\n    margin-right: 2em;\n  }\n}\n@media only screen and (min-width: 760px) {\n  .align-start .element {\n    scroll-snap-align: start;\n  }\n\n  .both-mandatory {\n    scroll-snap-type: both mandatory;\n  }\n  .element {\n    scroll-snap-stop: normal;\n\n    position: relative;\n  }\n  .wowhide {\n    opacity: 0;\n    -webkit-transition: all 0.6s ease-in-out;\n    transition: all 0.6s ease-in-out;\n    transform: translate(0, 50px);\n  }\n  .wowup {\n    transform: translate(0, 0);\n    opacity: 1;\n  }\n  @supports (scroll-snap-type: both mandatory) {\n    .no-support {\n      display: none;\n    }\n  }\n}\n.container {\n  width: 100%;\n  height: 100vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.container::-webkit-scrollbar {\n  width: 0;\n}\n.lefttext {\n  text-align: left;\n}\n\n/*About Page*/\n\n.about-banner {\n  height: 82vh;\n  /* background: #000 url(../assets/img/bg_hero_banner@3xabout.png) no-repeat 0 0; */\n  background-size: 100%;\n  background-position: bottom;\n  position: relative;\n  z-index: 1;\n}\n\ncanvas {\n  width: 100%;\n  height: 100%;\n}\n.seperator {\n  position: absolute;\n  width: 0.5em;\n  top: 90vh;\n  background-color: #000;\n  left: 50%;\n}\n.seperator-right {\n  padding-left: 5em;\n}\n.seperator-friendly {\n  position: relative;\n  z-index: 5;\n  padding: 2em 0;\n  background-color: #fff;\n}\n.form-function-text {\n  font-size: 2em;\n}\n.item p,\n.item-right p {\n  white-space: break-spaces;\n}\n.item-right p {\n  padding-right: 1em;\n}\n.left-of-seperator {\n  width: 45%;\n  text-align: right;\n  padding-right: 1em;\n  box-sizing: border-box;\n  overflow: hidden;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.services-content {\n  margin-top: 2em;\n  line-height: 2em;\n}\n.third-left-child {\n  margin-top: -8vh;\n}\n.right-of-seperator {\n  width: 45%;\n  text-align: left;\n  margin-top: -8vh;\n  box-sizing: border-box;\n  margin-left: 55%;\n  display: inline-block;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.services-text {\n  /* text-decoration: underline; */\n  /* padding-top: 2em; */\n  /* text-underline-offset: 5px; */\n  line-height: 2em;\n  font-size: 1em;\n  font-weight: 500;\n  /* text-decoration-thickness: 3px; */\n}\n\n@media only screen and (min-width: 760px) {\n  .item {\n    display: inline-block;\n    position: relative;\n    right: -100%;\n    width: 100%;\n    transition: right 0.7s cubic-bezier(0.075, 0.82, 0.165, 1),\n      transform 0.7s cubic-bezier(0.075, 0.82, 0.165, 1),\n      opacity 1.5s cubic-bezier(0.075, 0.82, 0.165, 1);\n    opacity: 0;\n  }\n  .item-right {\n    display: inline-block;\n    position: relative;\n    left: -105%;\n    width: 100%;\n    transition: right 0.7s cubic-bezier(0.075, 0.82, 0.165, 1),\n      transform 0.7s cubic-bezier(0.075, 0.82, 0.165, 1),\n      opacity 1.5s cubic-bezier(0.075, 0.82, 0.165, 1);\n    opacity: 0;\n  }\n  .item-display {\n    transform: translateX(-100%);\n    opacity: 1;\n  }\n  .item-display-right {\n    transform: translateX(110%);\n    opacity: 1;\n  }\n}\n.about-done-that {\n  background-color: #161616;\n  position: relative;\n  padding-top: 2em;\n}\n.about-done-that .content-section,\n.about-black .content-section {\n  color: #fff;\n}\n.nav-top-pad {\n  padding-top: 4em;\n}\n.reasons-heading {\n  font-size: 1.4em;\n  font-weight: 500;\n}\n.about-done-that .nav li {\n  width: 33%;\n  line-height: 2.7em;\n  text-transform: uppercase;\n  font-size: 0.85em;\n}\n.top-pad-1 {\n  padding-top: 1em;\n}\n.top-pad-3 {\n  padding-top: 3em;\n}\n.top-pad-2 {\n  padding-top: 2em;\n}\n.mobile-only {\n  display: none;\n}\n.reasons {\n  height: 50vh;\n  width: 100%;\n  background-size: 100%;\n  margin-top: 10% !important;\n  margin-bottom: 0px !important;\n}\n.padding-bottom-3 {\n  padding-bottom: 3em;\n}\n.padding-bottom-5 {\n  padding-bottom: 5em;\n}\n.text-align-right {\n  text-align: right;\n}\n\n.work-banner {\n  height: 90vh;\n  /* height updating for work page banner,  it was initially 65vh */\n  /* background: #000 url(../assets/img/bg_hero_work@3x.png) no-repeat 0 0; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-size: 100%;\n  background-position: bottom;\n  position: relative;\n  z-index: 1;\n}\n.contact-banner {\n  height: 55.5vh;\n  background-size: 100%;\n  background-position: bottom;\n  position: relative;\n  z-index: 1;\n}\n.work-banner h2 {\n  text-align: center;\n  color: #fff;\n  margin: 0;\n  font-size: 3em;\n}\n.contact-banner h2 {\n  text-align: center;\n  color: #fff;\n  font-size: 3em;\n}\n\n.about-banner h2 {\n  text-align: center;\n  color: #fff;\n  margin: 0;\n  position: absolute;\n  top: 60%;\n  left: 50%;\n  -ms-transform: translate(-51%, -50%);\n  transform: translate(-51%, -50%);\n  font-size: 3em;\n}\n\n.banner svg {\n  height: 100vh;\n}\n\n/* .work-details{\n    display: flex;\n    flex-direction: column;\n    scroll-snap-type: mandatory;\n    scroll-snap-type: y mandatory;\n    color: white;\n\n  } */\n.work-details-child {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction: row;\n  scroll-snap-align: start;\n}\n.about-banner > div,\n.work-banner > div {\n  width: 100%;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  top: 39%;\n  gap: 1em;\n}\n\n.contact-banner > div {\n  width: 100%;\n  position: absolute;\n  display: flex;\n  gap: 1rem;\n  flex-direction: column;\n  bottom: 0;\n}\n.odd-child {\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  scroll-snap-align: start;\n}\n.even-child {\n  background: #fff;\n  color: #000;\n  scroll-snap-align: start;\n}\n.solution-description {\n  width: 40%;\n  font-size: 0.8em;\n  padding: 0 2em 0;\n  box-sizing: border-box;\n  position: relative;\n  height: 100%;\n}\n.solution-description p {\n  margin: 0;\n  position: absolute;\n  width: 70%;\n  top: 50%;\n  left: 58%;\n  -ms-transform: translate(-79%, -50%);\n  transform: translate(-79%, -50%);\n  -webkit-transition: all 1s ease-in-out;\n  font-size: 1.2em;\n  opacity: 0;\n}\n.odd-child .solution-description a {\n  color: #fff;\n  font-weight: 500;\n}\n.even-child .solution-description a {\n  color: #000;\n  font-weight: 500;\n}\n.solution-description p.opposite {\n  -ms-transform: translate(-39%, -50%);\n  transform: translate(-39%, -50%);\n  opacity: 0;\n  /* transform: translate(10%, 0%); */\n  -ms-transform: translate(10%, 0%);\n  -webkit-transition: all 1s ease-in-out;\n  /* opacity: 0; */\n  overflow: hidden;\n}\n/*ANimation solution description p*/\n.solution-description p.animate {\n  transform: translate(-59%, -50%);\n  opacity: 1;\n  height: 75%;\n  /* transform: translate(10%, 0%); */\n  -ms-transform: translate(10%, 0%);\n  -webkit-transition: all 1s ease-in-out;\n  overflow: hidden;\n}\n.solution-description p.animate .industry-info {\n  color: rgba(176, 176, 176, 0.686);\n  font-size: 1.7rem;\n  font-weight: 500;\n  line-height: 3rem;\n}\n\n.work-details-child div.animate {\n  transform: translate(0%, 0%);\n  opacity: 1;\n}\n.solution-img {\n  width: 60%;\n  overflow: hidden;\n  transform: translate(10%, 0%);\n  -ms-transform: translate(10%, 0%);\n  -webkit-transition: all 1s ease-in-out;\n}\n.solution-img-opposite {\n  width: 60%;\n  overflow: hidden;\n  transform: translate(-10%, 0%);\n  -ms-transform: translate(-10%, 0%);\n  -webkit-transition: all 1s ease-in-out;\n}\n.ehr {\n  /* background: url(../assets/img/img_smart_ehr-min.jpeg) no-repeat 0% 30% !important; */\n  transform: translate(10%, 0%);\n  /* background-size: auto 103% !important; */\n  -ms-transform: translate(10%, 0%);\n  -webkit-transition: all 1s ease-in-out;\n  /* opacity: 0; */\n  overflow: hidden;\n  /* background-size: 100% !important; */\n  /* height: 80vh;\n    margin: 17vh 0; */\n}\n.pandemic {\n  /* background: url(../assets/img/img_pandamic-min.jpeg) no-repeat 0% 0% !important;\n    background-size: auto 100% !important; */\n  transform: translate(10%, 0%);\n  -ms-transform: translate(10%, 0%);\n  -webkit-transition: all 1s ease-in-out;\n  /* opacity: 0; */\n  overflow: hidden;\n}\n.itlfm {\n  background: url(../assets/img/img_smart_fleet-min.jpeg) no-repeat 0% 30% !important;\n  transform: translate(-10%, 0%);\n  -ms-transform: translate(-10%, 0%);\n  -webkit-transition: all 1s ease-in-out;\n  /* opacity: 0; */\n  overflow: hidden;\n  /* background-size: 100% !important;\n    height: 80vh;\n    margin: 17vh 0; */\n}\n.gta {\n  /* background: url(../assets/img/img_GTA-min.jpeg) no-repeat 100% 0% !important; */\n  transform: translate(-10%, 0%);\n  -ms-transform: translate(-10%, 0%);\n  -webkit-transition: all 1s ease-in-out;\n  /* opacity: 0; */\n  overflow: hidden;\n\n  /* background-size: auto 110% !important; */\n  /* height: 80vh;\n    margin: 17vh 0; */\n}\n.fleet {\n  /* background: url(../assets/img/img_smart_fleet-min.jpeg) no-repeat 50% 30% !important; */\n  transform: translate(-10%, 0%);\n  /* background-size: auto 100% !important; */\n  -ms-transform: translate(-10%, 0%);\n  -webkit-transition: all 1s ease-in-out;\n  /* opacity: 0; */\n  overflow: hidden;\n}\n.italos {\n  /* background: url(../assets/img/img_italos-min.jpeg) no-repeat 0% 0% !important; */\n  transform: translate(10%, 0%);\n  /* background-size: auto 100% !important; */\n  -ms-transform: translate(10%, 0%);\n  -webkit-transition: all 1s ease-in-out;\n  /* opacity: 0; */\n  overflow: hidden;\n}\n\n@keyframes showTopText {\n  0% {\n    transform: translate3d(0, 100%, 0);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n  }\n}\n.animated-title > div.text-top div {\n  animation: showTopText 0.7s cubic-bezier(0.075, 0.82, 0.165, 1);\n  animation-delay: 0.5s;\n  animation-fill-mode: forwards;\n  bottom: 0;\n  transform: translate(0, 100%);\n}\n\n.animated-title.second > div.text-top div {\n  animation-delay: 1s;\n}\n.animated-title.third > div.text-top div {\n  animation-delay: 1.25s;\n}\n.animated-title.fourth > div.text-top div {\n  animation-delay: 1.5s;\n}\n.animated-title > div {\n  height: 100%;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n}\n\n.animated-title {\n  height: 2em;\n  transform: translate(0%, -50%);\n}\n.fusion li {\n  width: auto;\n}\n\n.transparent {\n  color: transparent;\n}\n.magic-section-animate {\n  transform: translate(0%, 0px);\n  opacity: 1;\n}\nh3.magic-section-animate {\n  transform: translate(0%, -5px);\n  opacity: 1;\n}\n.colorfultext {\n  font-size: 1rem;\n  line-height: 2em;\n  /* letter-spacing: 3px; */\n  margin: auto;\n  width: 98%;\n  font-weight: 800;\n  background: linear-gradient(90deg, #ffde31 47.31%, #ff3db2 52.42%);\n  font-family: \"Poppins\", sans-serif;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-decoration: underline;\n  text-align: center;\n  cursor: pointer;\n}\n.MuiStepIcon-root {\n  color: white !important;\n}\n.MuiStepIcon-text {\n  fill: black !important;\n}\n.contact-banner .colorfultext {\n  font-size: 1rem;\n  line-height: 2em;\n  /* letter-spacing: 3px; */\n  margin: auto;\n  width: 98%;\n  font-weight: 800;\n  background: linear-gradient(90deg, #ffde31 46.31%, #ff3db2 52.42%);\n  font-family: \"Poppins\", sans-serif;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  text-decoration: underline;\n  text-align: center;\n  cursor: pointer;\n}\n.carousel-prev.block,\n.carousel-next.block {\n  height: 50vh;\n}\n\n.carousel-track,\n.carousel-item {\n  height: 50vh !important;\n}\n.carousel-item {\n  width: 45vw !important;\n  position: relative;\n  left: 18vw !important;\n}\n.carousel-row p {\n  position: absolute;\n  bottom: 20px;\n  width: 100%;\n  text-align: center;\n}\n.carousel-row p:nth-child(2) {\n  bottom: 0;\n}\n.carousel-row img {\n  height: 40vh;\n  width: 80%;\n}\n.carousel-bg {\n  width: 100%;\n  height: 40vh;\n}\n.bg-threatengine {\n  background: linear-gradient(#fff0 0%, #fff0 70%, #1d1d1d 100%),\n    url(../assets/img/ThreatEngine.png) no-repeat 0 0;\n  background-size: 100% auto;\n  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.2), 0px 0px 50px rgba(0, 0, 0, 0.2);\n}\n.bg-smartemr {\n  background: linear-gradient(#fff0 0%, #fff0 70%, #1d1d1d 100%),\n    url(../assets/img/EMR.png) no-repeat 0 0;\n  background-size: 100% 100%;\n  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.2), 0px 0px 50px rgba(0, 0, 0, 0.2);\n}\n.bg-processauto {\n  background: linear-gradient(#fff0 0%, #fff0 70%, #1d1d1d 100%),\n    url(../assets/img/processautomation.png) no-repeat 0 0;\n  background-size: 100% 100%;\n  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.2), 0px 0px 50px rgba(0, 0, 0, 0.2);\n}\n\nbutton.carousel-arrow:hover {\n  box-shadow: none !important;\n}\n.about-map-img {\n  width: 80%;\n  height: 70vh;\n  background-size: contain;\n  z-index: 1;\n  margin: auto;\n  margin-bottom: 0 !important;\n}\n.chat-widget {\n  width: 100%;\n  height: 70vh;\n  overflow: hidden;\n}\n.custom-questionnaire {\n  margin-bottom: 10em;\n  display: flex;\n  justify-content: center;\n  color: white;\n  margin: 0 0.5em;\n  padding-top: 4em;\n  overflow: hidden;\n  box-sizing: border-box;\n  /* max-height: 80vh; */\n  /* overflow-y: hidden; */\n\n  height: calc(100% - 4em);\n  position: relative;\n  /* z-index: 100; */\n}\n.MuiStepLabel-root .MuiStepLabel-labelContainer {\n  color: white;\n}\n.MuiStepLabel-root .MuiStepLabel-labelContainer .Mui-active {\n  color: white;\n  font-size: 1.3em;\n  font-weight: 600;\n}\n\n.MuiStepLabel-root .MuiStepLabel-labelContainer .Mui-active > p:nth-child(2) {\n  font-size: 0.85em;\n  font-weight: 100;\n}\n\n.MuiStepLabel-root .MuiStepLabel-labelContainer .Mui-active > a {\n  text-decoration: none;\n  color: white;\n  font-weight: 600;\n}\n\n.MuiStepLabel-root .MuiStepLabel-labelContainer .Mui-completed {\n  color: white;\n  font-size: 1.1em;\n  font-weight: 600;\n  cursor: pointer;\n}\n.nextChoice-container {\n  line-height: 1.6em;\n  padding: 0.75em 1.75em;\n  background-color: #333;\n  border: 1px solid #777;\n  margin-bottom: 1em;\n  border-radius: 0.5em;\n  cursor: pointer;\n  color: white;\n  transition: all 0.7s ease-in-out;\n}\n\n.nextChoice-container > div > div {\n  line-height: 1.4em;\n  font-size: 0.9em;\n}\n.nextChoice-container:hover {\n  background-color: #fff;\n  color: black;\n}\n.MuiButton-root {\n  width: 23%;\n  margin: 2em !important;\n}\n.thanksyou-wrapper {\n  display: flex;\n  width: 42vw;\n  text-align: center;\n  flex-direction: column;\n  align-items: center;\n  position: fixed;\n  top: 20em;\n}\n/* .carousel-item[data-carouselkey=\"0\"]{\n    transform: translateX(0px) translateX(250px) translateX(0px) !important;\n  }\n  .carousel-item[data-carouselkey=\"1\"]{\n    transform: translateX(0px) translateX(450px) !important;\n  }\n  .carousel-item[data-carouselkey=\"1\"]{\n    transform: translateX(0px) translateX(-736px) !important;\n  } */\n\n.masonry-container {\n  -webkit-column-count: 3;\n  -moz-column-count: 3;\n  column-count: 3;\n\n  -webkit-column-gap: 1.5em;\n  -moz-column-gap: 1.5em;\n  column-gap: 1.5em;\n  width: 100%;\n  /* margin-left: -5%; */\n}\n\n.masonry-item {\n  display: inline-block;\n  width: 100%;\n  /* transform: translate(0, 200px);  */\n  opacity: 0;\n}\n\n/* .masonry-item img:hover {\n  transform: scale(1.03);\n  border-radius: 5px;\n} */\n.masonry-item img {\n  display: block;\n  width: 100%;\n  cursor: pointer;\n  transition: transform 0.5s ease-in-out;\n  border-radius: 5px;\n}\n.masonry-container > .masonry-item {\n  transition: all 0.7s ease-in-out;\n  /* transition-delay: 0ms !important; */\n}\n\n/* Just for decoration: */\n.masonry-item span {\n  font-family: sans-serif;\n  display: block;\n  padding: 0.25em;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  text-align: left;\n}\n\n.masonry-item {\n  margin-bottom: 1.2em;\n\n  border-radius: 5px;\n  position: relative;\n}\n.user-icon {\n  background: url(../assets/img/user.png) no-repeat;\n}\n\n.user-box {\n  width: 100%;\n  background: #131313 url(../assets/img/user.png) no-repeat 3% 43%;\n  background-size: auto 40%;\n  color: #fff;\n  border: 1px solid #eee;\n  border-radius: 0.5em;\n  line-height: 3em;\n  height: 3.5em;\n  box-sizing: border-box;\n  padding-left: 4em;\n  margin: 0.5em;\n  outline: none;\n}\n.user-box::placeholder {\n  padding-left: 0em;\n}\n.user-box:focus::-webkit-input-placeholder {\n  opacity: 0;\n}\n\n.email-box {\n  width: 100%;\n  background: #131313 url(../assets/img/mail.png) no-repeat 3% 43%;\n  background-size: auto 40%;\n  color: #fff;\n  border: 1px solid #eee;\n  border-radius: 0.5em;\n  line-height: 3em;\n  height: 3.5em;\n  box-sizing: border-box;\n  padding-left: 4em;\n  margin: 0.5em;\n  outline: none;\n}\n\n.email-box::placeholder {\n  padding-left: 0em;\n}\n.email-box:focus {\n  outline: none;\n}\n.email-box:focus::-webkit-input-placeholder {\n  opacity: 0;\n}\n.email-submit {\n  margin-top: 0;\n  line-height: 1;\n  width: 100%;\n  height: 2.5em;\n  margin: 0.5em;\n  color: #161616;\n  box-sizing: border-box;\n  display: none;\n  padding: 0;\n  background: #eee url(../assets/img/Union.png) no-repeat 39% 57%;\n  background-size: auto 50%;\n  border-radius: 0.5em;\n  font-weight: 700;\n}\n.active {\n  display: block;\n}\n\n.say-hi-class {\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  background: #131313;\n  color: #fff;\n  width: 93%;\n  margin: 1em 0em 0em 0.3em;\n  outline: none;\n  border-radius: 0.5em;\n  border: 1px solid #eee;\n  padding: 2.5%;\n}\n\n.say-hi-class::placeholder {\n  color: #fff;\n  opacity: 0.5;\n  line-height: -5em;\n}\n.wrappper {\n  overflow-y: scroll;\n}\n.scrollable-div {\n  /* height: 150vh; */\n}\n.allow-scroll {\n  overflow: hidden;\n}\n.about-black {\n  background-color: #000;\n}\n.overlay {\n  width: 100vw;\n  height: 100vh;\n  background: black;\n  opacity: 0.7;\n  position: fixed;\n  top: 0em;\n  left: 0em;\n}\n.thankyou-font {\n  font-size: 3em;\n  bottom: 100%;\n}\n.MuiBox-root {\n  width: 42vw;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none;\n  overflow-x: hidden;\n}\n.MuiBox-root .MuiBox-root {\n  width: 100%;\n}\n/* Hide scrollbar for Chrome, Safari and Opera */\n.MuiBox-root::-webkit-scrollbar {\n  display: none;\n}\n\nspan.MuiStepLabel-vertical {\n  padding: 0.75em 0;\n}\nspan.MuiStepLabel-root {\n  align-items: flex-start;\n  -webkit-box-align: start;\n}\nspan.MuiStepLabel-iconContainer {\n  padding-top: 0.1em;\n}\n.nextChoice-container h5 {\n  font-size: 1.1em;\n  padding-bottom: 0.5em;\n}\n.active-menu {\n  text-decoration: underline;\n  text-decoration-thickness: 2px;\n  text-underline-offset: 0.2em;\n  font-weight: 600 !important;\n  background: linear-gradient(90deg, #ffde31 5.31%, #ff3db2 79.42%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  /* for border */\n  border-bottom: 3px solid transparent;\n  /* border-image: linear-gradient(90deg, #ffde31 5.31%, #ff3db2 79.42%); */\n  border-image-slice: 1;\n}\n.mailbox {\n  padding: 2.5em 2% 2.5em 3% !important;\n  background: url(../assets/img/mail_footer.png) no-repeat 0% 50%;\n  cursor: pointer;\n  text-decoration: none;\n  color: #fff;\n}\n.mailbox-nomail {\n  cursor: pointer;\n  text-decoration: none;\n  color: #fff;\n}\n.lazy-load-image-background {\n  overflow: hidden;\n}\n.lazy-images-odd {\n  width: auto;\n  height: 100vh;\n  object-fit: cover;\n}\n\n.lazy-images-even {\n  width: auto;\n  /* margin-left: -52%; */\n  height: 100vh;\n  object-fit: cover;\n}\n\n.fleetimg {\n  width: 152%;\n  margin-left: -52%;\n}\n\n#pandemic .lazy-images-odd,\n.ehr .lazy-images-odd {\n  /* width: 110%; */\n}\n.fleet img {\n  height: 100vh;\n  width: auto;\n  margin-left: -35%;\n}\n.fleet .picarroimg {\n  margin-left: 0%;\n  margin-top: -6%;\n\n  height: 100vh;\n  margin: 0;\n}\n.ehr img {\n  margin-left: -10%;\n}\n.gta img {\n  height: 100vh;\n\n  margin-left: 0;\n}\n\n#mouse-circle {\n  position: absolute;\n  width: 50px;\n  height: 50px;\n  margin: -32px 0px 0px -32px;\n  pointer-events: none !important;\n  /* border-image-source: linear-gradient(90deg, #ffde31 47.31%, #ff3db2 52.42%); */\n  box-shadow: 0 0 16px rgba(255, 255, 255, 0);\n  /* for smooth scaling */\n  transition: transform 0.2s ease-in-out;\n  /* border: 2px solid #fff; */\n  border-radius: 50%;\n  border-radius: 50px; /*1*/\n  border: 1.5px solid transparent;\n  background: linear-gradient(45deg, #ffde31, #ff3db2) border-box; /*3*/\n  -webkit-mask: /*4*/ linear-gradient(#fff 0 0) padding-box,\n    linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor; /*5'*/\n  mask-composite: exclude; /*5*/\n}\n\n.scroll-down {\n  position: absolute;\n  bottom: 2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  text-align: center;\n}\n\n.ul {\n  display: block;\n  padding-inline-start: 1.5rem;\n  list-style: disc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
